import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Footer from '../components/Layout/Footer'
import CareerInfo from '../components/Career/CareerInfo'
import ContactBreadcrub from '../components/Career/CareerBreadcrub'


const ContactPage = () => {
  return (
    <div>
        <NavbarTwo />
        <div className='2xl:pt-[90px] pt-[50px] xl:pt-[80px] lg:pt-[70px]'>
        <ContactBreadcrub/>    
        <CareerInfo/>
        <Footer/>
        </div>
    </div>
  )
}

export default ContactPage;
